module.exports = __webpack_public_path__ + "img/arrow-black.5a3b31f1.svg";